import { render, staticRenderFns } from "./PdvPlpExternalRegister.vue?vue&type=template&id=08e711c1"
import script from "./PdvPlpExternalRegister.vue?vue&type=script&lang=js"
export * from "./PdvPlpExternalRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports